import { render } from "./BubblePrincipal.vue?vue&type=template&id=913108f6"
import script from "./BubblePrincipal.vue?vue&type=script&lang=js"
export * from "./BubblePrincipal.vue?vue&type=script&lang=js"

import "./BubblePrincipal.vue?vue&type=style&index=0&id=913108f6&lang=css"
script.render = render

export default script